import { FirearmStorageLocationPLIItemComponentBase } from './firearm-storage-location-pli-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { requiredValidator, CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { FirearmStorageLocationPLIService, FirearmStorageLocationService } from 'assets-service';
import moment from 'moment';


@Component({
  selector: 'app-firearm-storage-location-pli-item',
  templateUrl: './firearm-storage-location-pli-item.component.html',
  styleUrls: ['./firearm-storage-location-pli-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmStorageLocationPLIItemComponent extends FirearmStorageLocationPLIItemComponentBase {

  createForm(): FormGroup {
    const form = super.createForm();
    form.get('validFromDate').setValidators(requiredValidator);
    form.get('validToDate').setValidators(requiredValidator);
    form.setValidators(group => {
      const from = group.get('validFromDate').value;
      const to = group.get('validToDate').value;
      return from && to && new Date(to).getTime() < new Date(from).getTime()
        ? { dateOrder: true } : null;
    });
    return form;
  }

  validFromDateChangedByUser(value: Date, unsetDependents?: boolean): void {
    if (value != null) {
      const candidateDate = value instanceof Date ? value : new Date(value as any);
      if (!isNaN(candidateDate.getTime()) && this.item.validToDate == null) {
        this.item.validToDate = moment(candidateDate).add(1, 'years').toDate();
      }
    }
  }

  setDefaultDisabledFields() {
    super.setDefaultDisabledFields();
    ['firearmStorageLocationPLIId', 'firearmStorageLocation', 'createdBy', 'createdDate',
      'updatedBy', 'updatedDate', 'documentUploadedBy', 'hasDocuments', 'lockVersion'].forEach(
        name => this.form?.get(name)?.disable({ emitEvent: false }));
  }

  documentsChanged(documents: any[]): void {
    Object.assign(this.item, {
      hasDocuments: documents.length > 0,
      documentUploadedBy: documents[0]?.documentUploadedBy
    });
    this.hasDocuments?.setValue(this.item.hasDocuments, { emitEvent: false });
    // Document mutations increment the optimistic version; retain unsaved date/comment edits.
    this.firearmStorageLocationPLIService.get(this.item.firearmStorageLocationPLIId).subscribe(saved => {
      this.item.lockVersion = saved.lockVersion;
    });
  }

  constructor(protected firearmStorageLocationPLIService: FirearmStorageLocationPLIService,
    protected firearmStorageLocationService: FirearmStorageLocationService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(firearmStorageLocationPLIService, firearmStorageLocationService, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

  }
    
  itemSet() {
    if (this.createMode && this.route.snapshot.data.storageLocation) {
      this.item.firearmStorageLocation = this.route.snapshot.data.storageLocation;
    }
    this.firearmStorageLocationSelectionList = this.item?.firearmStorageLocation ? [this.item.firearmStorageLocation] : [];
    super.itemSet();
  }
  
}





